import React, {PropsWithChildren} from 'react';

import cn from 'classnames';
import styled from '@emotion/styled';

import {useId} from '@britishcouncil/react-common';
import {FormFieldProps} from '@britishcouncil/react-forms';
import {BcCheckbox as BcCheckBoxBase, FieldError, FieldProps} from '@britishcouncil/react-solas-ors3';

type Props = PropsWithChildren<FormFieldProps<boolean>> & FieldProps;

const S = {
    Container : styled.div`
        .checkbox {
            margin-bottom: 0px;
        }
        .form-group {
            margin-bottom: 0px;
        }
    `
}

export const BcCheckbox = ({ children, touched, error,  onChange, ...inputProps}: Props) => {
    const generatedId = useId(`${inputProps.name}-`);
    const id = inputProps.id || generatedId;
    return (
        <S.Container className={cn('form-group form-checkbox', {'has-error': touched && error})}>
            <div className="checkbox">
                <label htmlFor={id} style={{paddingLeft: '10px'}}>
                    <BcCheckBoxBase {...inputProps} id={id} checked={inputProps.value} handleChange={onChange} background="gray">
                        {children}
                    </BcCheckBoxBase>
                </label>
            </div>
            {touched && error && <FieldError error={error} touched={touched}/>}
        </S.Container>
    );
};
